module.exports = __webpack_public_path__ + "img/Big.bf18549.svg";